


const applicationStateTitle = {
    0: '待处理', 
    1: '待退货', 
    2: '退货中',
    4: '待退款', 
    5: '退款审核中', 
    7: '已完成', 
    9: '已拒绝'
}
const refundCauseTitle = {
    1: '多拍/拍错/不想要',
    2: '缺货',
    5: '缺少件',
    6: '发错货',
    7: '质量问题',
    8: '商品与描述不符',
    9: '商品损坏',
    10: '其它原因'
}
const goodsKindsTitle = {
    1: '普通培训商品', 
    2: '分销培训商品', 
    3: '实体商品', 
    4:'会员商品', 
    5: '组合商品'
}
const statusTitle = {
    0: '退款申请审核中',
    1: '申请已受理，请将商品寄回并填写退货单号',
    2: '货品已寄回，待售后确认',
    4: '待售后确认退款', 
    5: '等待财务确认退款中', 
    7: '售后处理已完成', 
    9: '退款已拒绝'
}
const recordTitle = {
    0: '您的退款or退款退货服务单已提交成功，待售后审核中',
    1: '您的退款退货受理申请已通过，请将商品寄回售后地址，并务必填写退货信息',
    2: '您的退款受理申请已通过',
    4: '您的退款退货商品已收到', 
    5: '您的服务单已提交退款申请，等待财务确认', 
    7: '财务已确认退款，请您注意查收', 
    8: '退款成功',
    9: '您的退款申请被拒绝'
}
const refundTitle = {
    0: '您的退款申请被拒绝',
    2: '您的收货处理被拒绝',
    4: '您的退款处理被拒绝',
    5: '您的退款审核被拒绝',
}



export default {
    applicationStateTitle,
    refundCauseTitle,
    goodsKindsTitle,
    statusTitle,
    recordTitle,
    refundTitle
}